export default __webpack_public_path__ + "static/media/GR10 10-B-2EC.040b609e.jpg";